import {
  ValidateIf,
  IsString,
  IsNotEmpty,
  IsOptional,
  IsArray,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import { StartTaskDto } from './start-task.dto';
import { BranchTaskDto } from './branch-task.dto';
import { UserTaskDto } from './user-task.dto';
import { ParallelGroupDto } from './parallel-group.dto';
import { SystemTaskDto } from './system-task.dto';
import { FinishTaskDto } from './finish-task.dto';
import { FlowEdgeDto } from './flow-edge.dto';

export type NodeData =
  | StartTaskDto
  | UserTaskDto
  | BranchTaskDto
  | ParallelGroupDto
  | SystemTaskDto
  | FinishTaskDto;

export class CreateEventTypeDto {
  @IsString()
  @IsNotEmpty({ message: 'Обязательное поле' })
  companyId: string;

  @ValidateIf((dto: CreateEventTypeDto) => !!dto.customType)
  @IsString()
  @IsNotEmpty({ message: 'Обязательное поле' })
  groupTypes: string;

  @IsString()
  @IsNotEmpty({ message: 'Обязательное поле' })
  eventType: string;

  @IsString()
  @IsOptional()
  customType?: string;

  nodes: Record<string, NodeData>;

  @IsArray()
  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => FlowEdgeDto)
  edges?: FlowEdgeDto[];

  @IsArray()
  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => FlowEdgeDto)
  returns?: FlowEdgeDto[];
}
